module.exports = __webpack_public_path__ + "img/4-tablet.80df0ace.webp";